import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconChevronDownComponent } from './icon-chevron-down/icon-chevron-down.component';
import { IconArrowLineRightComponent } from './icon-arrow-line-right/icon-arrow-line-right.component';
import { DynamicCategoryIconComponent } from './dynamic-category-icon/dynamic-category-icon.component';
import { IconBookComponent } from './icon-book/icon-book.component';
import { IconCameraComponent } from './icon-camera/icon-camera.component';
import { IconClipboardComponent } from './icon-clipboard/icon-clipboard.component';
import { IconDocumentComponent } from './icon-document/icon-document.component';
import { IconEnvelopeComponent } from './icon-envelope/icon-envelope.component';
import { IconEnvelopeOpenComponent } from './icon-envelope-open/icon-envelope-open.component';
import { IconExitComponent } from './icon-exit/icon-exit.component';
import { IconEyeComponent } from './icon-eye/icon-eye.component';
import { IconEyeCrossedComponent } from './icon-eye-crossed/icon-eye-crossed.component';
import { IconHeartFillComponent } from './icon-heart-fill/icon-heart-fill.component';
import { IconHeartOutlineComponent } from './icon-heart-outline/icon-heart-outline.component';
import { IconHomeComponent } from './icon-home/icon-home.component';
import { IconMenuComponent } from './icon-menu/icon-menu.component';
import { IconMicrophoneComponent } from './icon-microphone/icon-microphone.component';
import { IconNoteComponent } from './icon-note/icon-note.component';
import { IconPaperPlaneComponent } from './icon-paper-plane/icon-paper-plane.component';
import { IconSearchComponent } from './icon-search/icon-search.component';
import { IconStarComponent } from './icon-star/icon-star.component';
import { IconTrophyComponent } from './icon-trophy/icon-trophy.component';
import { IconPhoneComponent } from './icon-phone/icon-phone.component';
import { IconBellComponent } from './icon-bell/icon-bell.component';
import { IconChevronRightComponent } from './icon-chevron-right/icon-chevron-right.component';


@NgModule({
  declarations: [
    IconChevronDownComponent,
    IconArrowLineRightComponent,
    DynamicCategoryIconComponent,
    IconBookComponent,
    IconCameraComponent,
    IconChevronDownComponent,
    IconClipboardComponent,
    IconDocumentComponent,
    IconEnvelopeComponent,
    IconEnvelopeOpenComponent,
    IconExitComponent,
    IconEyeComponent,
    IconEyeCrossedComponent,
    IconHeartFillComponent,
    IconHeartOutlineComponent,
    IconHomeComponent,
    IconMenuComponent,
    IconMicrophoneComponent,
    IconNoteComponent,
    IconPaperPlaneComponent,
    IconSearchComponent,
    IconStarComponent,
    IconTrophyComponent,
    IconPhoneComponent,
    IconBellComponent,
    IconChevronRightComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    IconChevronDownComponent,
    IconArrowLineRightComponent,
    DynamicCategoryIconComponent,

    IconBookComponent,
    IconCameraComponent,
    IconChevronDownComponent,
    IconClipboardComponent,
    IconDocumentComponent,
    IconEnvelopeComponent,
    IconEnvelopeOpenComponent,
    IconExitComponent,
    IconEyeComponent,
    IconEyeCrossedComponent,
    IconHeartFillComponent,
    IconHeartOutlineComponent,
    IconHomeComponent,
    IconMenuComponent,
    IconMicrophoneComponent,
    IconNoteComponent,
    IconPaperPlaneComponent,
    IconSearchComponent,
    IconStarComponent,
    IconTrophyComponent,
    IconPhoneComponent,
    IconBellComponent,
    IconChevronRightComponent
  ]
})
export class IconModule { }
